import React, { useRef } from "react";
import { Box } from "@mui/material";
import Card from "components/basic/card";
import useOffsetTop from "hooks/useOffsetTop";

interface SignUpCardLayoutProps {
  children: React.ReactNode;
}

// The single-card signup steps. A min-height rather than a fixed one, so a short
// screen or an open phone keyboard scrolls the page instead of clipping the card.
const SignUpCardLayout: React.FC<SignUpCardLayoutProps> = ({ children }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const offsetTop = useOffsetTop(rootRef);

  return (
    <Box
      ref={rootRef}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: `calc(100dvh - ${offsetTop}px)`,
        px: 2,
        py: { xs: 3, sm: 4 },
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 500 }}>
        <Card disableVerticalPadding square dark>
          <Box sx={{ px: { xs: 2, sm: 4 } }}>{children}</Box>
        </Card>
      </Box>
    </Box>
  );
};

export default SignUpCardLayout;
